import * as dayjs from "dayjs";
import "dayjs/locale/zh-cn";

class JTime {
  constructor() {
    this.date = dayjs;
    this.date.locale("zh-cn");
  }

  formatTime(value, format = "YYYY/MM/DD HH:mm:ss") {
    return this.date(value).format(format);
  }
  add(currentTime, number, type) {
    return this.date(currentTime)
      .add(number, type)
      .valueOf();
  }
}

export default new JTime();



// WEBPACK FOOTER //
// ./src/utils/time.js